import { useEffect, useState } from "react";
import { Loader2, Save } from "lucide-react";
import { toast } from "sonner";
import { api, errDetail } from "@/lib/api";
import type { EmailSettings as S } from "./emailSettingsTypes";
import { BrandSection, FieldsSection, TemplatesSection } from "./EmailSettingsForm";
import { EmailPreview } from "./EmailPreview";

export default function EmailSettings() {
  const [s, setS] = useState<S | null>(null);
  const [kind, setKind] = useState("paid");
  const [lang, setLang] = useState<"es" | "en">("es");
  const [saving, setSaving] = useState(false);
  const [version, setVersion] = useState(0);
  useEffect(() => { api.get("/staff/email-settings").then(({ data }) => setS(data)).catch((e) => toast.error(errDetail(e))); }, []);
  if (!s) return <div className="grid place-items-center py-20"><Loader2 className="h-8 w-8 animate-spin text-slate-400" /></div>;
  const set = (fn: (p: S) => S) => setS((p) => (p ? fn(p) : p));
  const save = async () => {
    setSaving(true);
    try { const { data } = await api.put("/staff/email-settings", s); setS(data); setVersion((v) => v + 1); toast.success("Correos actualizados"); }
    catch (e) { toast.error(errDetail(e)); } finally { setSaving(false); }
  };
  const props = { s, set, kind, setKind };
  return (
    <div data-testid="email-settings-page">
      <div className="flex flex-wrap items-center justify-between gap-4">
        <div><h1 className="font-display text-3xl sm:text-4xl text-[#0B192C]">Correos</h1><p className="mt-1 text-sm text-slate-500">Personaliza los correos que reciben tus clientes (ES/EN), los datos que muestran y envía pruebas.</p></div>
        <button onClick={save} disabled={saving} data-testid="email-save-btn" className="inline-flex items-center gap-2 rounded-full bg-[#D4AF37] px-5 py-2.5 text-sm font-semibold text-[#0B192C] disabled:opacity-60">{saving ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}Guardar cambios</button>
      </div>
      <div className="mt-6 grid gap-6 xl:grid-cols-[1.1fr_1fr] items-start">
        <div className="space-y-6"><TemplatesSection {...props} /><FieldsSection {...props} /><BrandSection {...props} /></div>
        <div className="xl:sticky xl:top-6"><EmailPreview kind={kind} lang={lang} setLang={setLang} version={version} /></div>
      </div>
    </div>
  );
}
